import React from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import './LegalPage.css';

const TermsPage = () => (
  <div className="legal-page">
    <Navbar />
    <main>
      <section className="legal-hero">
        <div className="legal-hero__inner">
          <p className="section-eyebrow">Legal</p>
          <h1 className="legal-hero__title">Terms of Service</h1>
          <p className="legal-hero__date">Last updated: April 2025</p>
          <div className="gold-divider" style={{ maxWidth: 180, margin: '1.25rem auto 0' }} />
        </div>
      </section>

      <section className="legal-body">
        <div className="legal-body__inner">

          <LegalSection title="1. Acceptance of Terms">
            <p>By using VTD Astrology's services — including any consultation booked via WhatsApp, Instagram, or our website — you agree to these Terms of Service. If you do not agree, please do not proceed with booking.</p>
          </LegalSection>

          <LegalSection title="2. Nature of Services">
            <p>VTD Astrology offers Vedic astrology consultations, tarot readings, palmistry, numerology, Vastu consultations and personalised remedies. These services are provided for:</p>
            <ul>
              <li>Spiritual guidance and self-understanding</li>
              <li>Personal insight and life planning support</li>
              <li>Entertainment and educational purposes</li>
            </ul>
            <p>Astrology readings are <strong>not a substitute</strong> for professional medical, legal, financial, or psychological advice. VTD Astrology does not guarantee specific outcomes.</p>
          </LegalSection>

          <LegalSection title="3. Booking and Payment">
            <ul>
              <li>Consultations are booked via WhatsApp by mutual agreement on date and time.</li>
              <li>Payment is required in advance via UPI or bank transfer before the session begins.</li>
              <li>Session timing and format (call, chat, report) will be confirmed at the time of booking.</li>
              <li>Prices are communicated directly and are fixed for the agreed service.</li>
            </ul>
          </LegalSection>

          <LegalSection title="4. Refund Policy" id="refund">
            <p><strong>Standard Sessions:</strong> Refunds are provided if the astrologer is unable to deliver the promised session due to cancellation on our side. In such cases, a full refund will be processed within 3–5 business days.</p>
            <p><strong>Completed Sessions:</strong> Once a session has been delivered (call completed or report sent), no refund is applicable. If you are unsatisfied with the session, please contact us — we will work to address your concerns.</p>
            <p><strong>Rescheduling:</strong> Sessions can be rescheduled with at least 4 hours' notice. Rescheduling requests made less than 4 hours before the session may forfeit the booking.</p>
            <p><strong>Remedy Consultations:</strong> Refunds are not available for personalised remedy plans that have been delivered, as these involve significant preparation time.</p>
          </LegalSection>

          <LegalSection title="5. Disclaimer of Liability">
            <p>VTD Astrology and its practitioners shall not be held liable for any decisions made based on astrological guidance. Life decisions remain entirely your responsibility. Past accuracy in predictions does not guarantee future accuracy.</p>
            <p>We do not accept liability for any emotional distress caused by the content of readings. If you are experiencing a mental health crisis, please contact a qualified mental health professional.</p>
          </LegalSection>

          <LegalSection title="6. Intellectual Property">
            <p>All content on vtdastrology.com — including text, graphics, SVGs, videos, and software — is the intellectual property of VTD Astrology. Reproduction without written permission is prohibited.</p>
          </LegalSection>

          <LegalSection title="7. Governing Law">
            <p>These terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of the courts in Hyderabad, Telangana, India.</p>
          </LegalSection>

          <LegalSection title="8. Contact">
            <p>For questions about these terms, contact us on WhatsApp at +91 93477 09596.</p>
          </LegalSection>

        </div>
      </section>
    </main>
    <Footer />
  </div>
);

const LegalSection = ({ title, children, id }) => (
  <div className="legal-section" id={id}>
    <h2 className="legal-section__title">{title}</h2>
    <div className="legal-section__body">{children}</div>
  </div>
);

export default TermsPage;
